var _desc, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFileWmfBw(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 63,
    viewBox: "0 0 50 63",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created using Figma")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file-wmf-bw_svg__file-wmf-bw_svg__Canvas",
    transform: "translate(10230 -935)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-wmf-bw_svg__file-wmf-bw_svg__file-wmf-bw"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-wmf-bw_svg__file-wmf-bw_svg__Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-wmf-bw_svg__file-wmf-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-wmf-bw_svg__file-wmf-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-wmf-bw_svg__file-wmf-bw_svg__path0_fill",
    transform: "matrix(1 0 0 -1 -10218 966.368)",
    fill: "#FFFFFF"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "file-wmf-bw_svg__file-wmf-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-wmf-bw_svg__file-wmf-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-wmf-bw_svg__file-wmf-bw_svg__path1_fill",
    transform: "matrix(1 0 0 -1 -10213.5 974.665)",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "file-wmf-bw_svg__file-wmf-bw_svg__mask0_alpha",
    "mask-type": "alpha"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-wmf-bw_svg__file-wmf-bw_svg__mask0_outline_ins"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-wmf-bw_svg__file-wmf-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-wmf-bw_svg__file-wmf-bw_svg__path1_fill",
    transform: "matrix(1 0 0 -1 -10213.5 974.665)",
    fill: "#FFFFFF"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "file-wmf-bw_svg__file-wmf-bw_svg__Group",
    mask: "url(#file-wmf-bw_svg__file-wmf-bw_svg__mask0_alpha)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-wmf-bw_svg__file-wmf-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-wmf-bw_svg__file-wmf-bw_svg__path2_fill",
    transform: "matrix(1 0 0 -1 -10214.3 975.527)",
    fill: "#4F4F4F"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "file-wmf-bw_svg__file-wmf-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-wmf-bw_svg__file-wmf-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-wmf-bw_svg__file-wmf-bw_svg__path3_fill",
    transform: "matrix(1 0 0 -1 -10210.7 972.009)",
    fill: "#4F4F4F"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "file-wmf-bw_svg__file-wmf-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-wmf-bw_svg__file-wmf-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-wmf-bw_svg__file-wmf-bw_svg__path3_fill",
    transform: "matrix(1 0 0 -1 -10210.7 968.854)",
    fill: "#4F4F4F"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "file-wmf-bw_svg__file-wmf-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-wmf-bw_svg__file-wmf-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-wmf-bw_svg__file-wmf-bw_svg__path3_fill",
    transform: "matrix(1 0 0 -1 -10210.7 965.728)",
    fill: "#4F4F4F"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "file-wmf-bw_svg__file-wmf-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-wmf-bw_svg__file-wmf-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-wmf-bw_svg__file-wmf-bw_svg__path4_fill",
    transform: "matrix(1 0 0 -1 -10210.7 962.572)",
    fill: "#4F4F4F"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "file-wmf-bw_svg__file-wmf-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-wmf-bw_svg__file-wmf-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-wmf-bw_svg__file-wmf-bw_svg__path5_fill",
    transform: "matrix(1 0 0 -1 -10198.4 972.009)",
    fill: "#4F4F4F"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "file-wmf-bw_svg__file-wmf-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-wmf-bw_svg__file-wmf-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-wmf-bw_svg__file-wmf-bw_svg__path5_fill",
    transform: "matrix(1 0 0 -1 -10198.4 968.854)",
    fill: "#4F4F4F"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "file-wmf-bw_svg__file-wmf-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-wmf-bw_svg__file-wmf-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-wmf-bw_svg__file-wmf-bw_svg__path5_fill",
    transform: "matrix(1 0 0 -1 -10198.4 965.728)",
    fill: "#4F4F4F"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "file-wmf-bw_svg__file-wmf-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-wmf-bw_svg__file-wmf-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-wmf-bw_svg__file-wmf-bw_svg__path6_fill",
    transform: "matrix(1 0 0 -1 -10198.4 962.572)",
    fill: "#4F4F4F"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "file-wmf-bw_svg__file-wmf-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-wmf-bw_svg__file-wmf-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-wmf-bw_svg__file-wmf-bw_svg__path4_fill",
    transform: "matrix(1 0 0 -1 -10210.7 959.553)",
    fill: "#4F4F4F"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "file-wmf-bw_svg__file-wmf-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-wmf-bw_svg__file-wmf-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-wmf-bw_svg__file-wmf-bw_svg__path6_fill",
    transform: "matrix(1 0 0 -1 -10198.4 959.553)",
    fill: "#4F4F4F"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "file-wmf-bw_svg__file-wmf-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-wmf-bw_svg__file-wmf-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-wmf-bw_svg__file-wmf-bw_svg__path7_fill",
    transform: "matrix(1 0 0 -1 -10206.2 968.189)",
    fill: "#4F4F4F"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "file-wmf-bw_svg__file-wmf-bw_svg__file-wmf"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-wmf-bw_svg__file-wmf-bw_svg__Canvas"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-wmf-bw_svg__file-wmf-bw_svg__Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-wmf-bw_svg__file-wmf-bw_svg__Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-wmf-bw_svg__file-wmf-bw_svg__Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-wmf-bw_svg__file-wmf-bw_svg__Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-wmf-bw_svg__file-wmf-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-wmf-bw_svg__file-wmf-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-wmf-bw_svg__file-wmf-bw_svg__path8_fill",
    transform: "translate(-10230 935)",
    fill: "#D9DEE0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "file-wmf-bw_svg__file-wmf-bw_svg__Burger_Angus_Burger"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-wmf-bw_svg__file-wmf-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-wmf-bw_svg__file-wmf-bw_svg__path9_fill",
    transform: "translate(-10218.1 979.119)",
    fill: "#FFFFFF"
  })))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "file-wmf-bw_svg__file-wmf-bw_svg__path0_fill",
    d: "M 2.00509 0.771819L 5.80639 0L 17.8304 9.4341L 18.1269 10.2382C 18.3157 10.8901 18.2078 11.5942 17.8304 12.168C 17.4799 12.7417 16.8868 13.1589 16.2128 13.3154L 5.80639 15.7667C 5.61769 15.8189 5.40202 15.845 5.18635 15.845C 4.70107 15.845 4.24276 15.7146 3.81139 15.4799C 3.21828 15.1409 2.78692 14.5672 2.62517 13.9152L 0.0909576 3.84904C -0.0977599 3.19709 0.0100785 2.49298 0.387514 1.91926C 0.73799 1.34554 1.3311 0.92829 2.00509 0.771819Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-wmf-bw_svg__file-wmf-bw_svg__path1_fill",
    d: "M 2.97151 0L 16.6405 0C 18.267 0 19.612 1.31411 19.612 2.97238L 19.612 16.6453C 19.612 18.2723 18.2983 19.6177 16.6405 19.6177L 2.97151 19.6177C 1.345 19.6177 0 18.3036 0 16.6453L 0 2.97238C 0 1.3454 1.31372 0 2.97151 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-wmf-bw_svg__file-wmf-bw_svg__path2_fill",
    d: "M 17.5026 -2.61531e-09L 3.8337 -2.61531e-09L 3.8337 1.72439L 17.5026 1.72439L 17.5026 -2.61531e-09ZM 3.8337 -2.61531e-09C 1.6936 -2.61531e-09 -2.61531e-09 1.73757 -2.61531e-09 3.83458L 1.72439 3.83458C 1.72439 2.6776 2.65823 1.72439 3.8337 1.72439L 3.8337 -2.61531e-09ZM -2.61531e-09 3.83458L -2.61531e-09 17.5075L 1.72439 17.5075L 1.72439 3.83458L -2.61531e-09 3.83458ZM -2.61531e-09 17.5075C -2.61531e-09 19.6477 1.7367 21.3421 3.8337 21.3421L 3.8337 19.6177C 2.67769 19.6177 1.72439 18.684 1.72439 17.5075L -2.61531e-09 17.5075ZM 3.8337 21.3421L 17.5026 21.3421L 17.5026 19.6177L 3.8337 19.6177L 3.8337 21.3421ZM 17.5026 21.3421C 19.6428 21.3421 21.3364 19.6046 21.3364 17.5075L 19.612 17.5075C 19.612 18.6645 18.6781 19.6177 17.5026 19.6177L 17.5026 21.3421ZM 21.3364 17.5075L 21.3364 3.83458L 19.612 3.83458L 19.612 17.5075L 21.3364 17.5075ZM 21.3364 3.83458C 21.3364 1.69446 19.5997 -2.61531e-09 17.5026 -2.61531e-09L 17.5026 1.72439C 18.6587 1.72439 19.612 2.65814 19.612 3.83458L 21.3364 3.83458Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-wmf-bw_svg__file-wmf-bw_svg__path3_fill",
    d: "M 1.5367 0L 0 0L 0 1.48645L 1.5367 1.48645L 1.5367 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-wmf-bw_svg__file-wmf-bw_svg__path4_fill",
    d: "M 1.5367 0L 0 0L 0 1.48646L 1.5367 1.48646L 1.5367 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-wmf-bw_svg__file-wmf-bw_svg__path5_fill",
    d: "M 1.5367 0L -4.45403e-14 0L -4.45403e-14 1.48645L 1.5367 1.48645L 1.5367 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-wmf-bw_svg__file-wmf-bw_svg__path6_fill",
    d: "M 1.5367 0L -4.45403e-14 0L -4.45403e-14 1.48646L 1.5367 1.48646L 1.5367 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-wmf-bw_svg__file-wmf-bw_svg__path7_fill",
    d: "M 0.296556 6.58474C 0.242636 6.58474 0.188717 6.58474 0.161758 6.55864C 0.0539188 6.50652 -6.34803e-15 6.40219 -6.34803e-15 6.29787L -6.34803e-15 0.299899C -6.34803e-15 0.195586 0.0539188 0.0912734 0.161758 0.0391173C 0.269596 -0.0130391 0.377435 -0.0130391 0.458315 0.0391173L 5.49978 3.03811C 5.58064 3.09026 5.63458 3.19457 5.63458 3.29889C 5.63458 3.4032 5.58064 3.48144 5.49978 3.55967L 0.458315 6.53258C 0.404395 6.55864 0.350475 6.58474 0.296556 6.58474Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-wmf-bw_svg__file-wmf-bw_svg__path8_fill",
    d: "M 35.7147 0L 3.57076 0C 1.60081 0 7.27601e-17 1.55148 7.27601e-17 3.47066L 7.27601e-17 58.6161C 7.27601e-17 60.5333 1.60081 62.087 3.57076 62.087L 46.4292 62.087C 48.4033 62.087 50 60.5333 50 58.6161L 50 13.8826L 35.7147 0ZM 35.7147 4.90695L 44.951 13.8826L 35.7147 13.8826L 35.7147 4.90695ZM 46.4296 58.6161L 3.57076 58.6161L 3.57076 3.47066L 32.1432 3.47066L 32.1432 13.8826C 32.1432 15.7997 33.7404 17.3533 35.7139 17.3533L 46.4292 17.3533L 46.4292 58.6161L 46.4296 58.6161Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-wmf-bw_svg__file-wmf-bw_svg__path9_fill",
    d: "M 9.08405 4.6792e-08C 9.22199 4.6792e-08 9.32545 0.0413831 9.39442 0.124153C 9.46343 0.206928 9.49792 0.317287 9.49792 0.455239C 9.49792 0.5587 9.48412 0.655265 9.45654 0.744932L 7.37689 7.64589C 7.32861 7.77698 7.25621 7.88387 7.15965 7.96663C 7.06999 8.0425 6.96306 8.08046 6.83891 8.08046C 6.71476 8.08046 6.60437 8.0425 6.50781 7.96663C 6.41125 7.88387 6.34227 7.78041 6.30089 7.65626L 4.75931 1.69679L 3.197 7.64589C 3.14871 7.77698 3.07632 7.88387 2.97971 7.96663C 2.89005 8.0425 2.78316 8.08046 2.65901 8.08046C 2.53484 8.08046 2.42448 8.0425 2.32792 7.96663C 2.23135 7.89076 2.16238 7.78731 2.12099 7.65626L 0.0413872 0.744932C 0.0137943 0.655265 2.33172e-09 0.562149 2.33172e-09 0.465584C 2.33172e-09 0.320735 0.0379386 0.206928 0.113812 0.124153C 0.196582 0.0413831 0.306941 4.6792e-08 0.444893 4.6792e-08C 0.569046 4.6792e-08 0.675956 0.0344859 0.765628 0.103462C 0.862193 0.172438 0.931169 0.272451 0.972552 0.403506L 2.66934 6.3009L 4.23165 0.465584C 4.25924 0.362118 4.32132 0.2759 4.41788 0.206928C 4.51444 0.137952 4.62479 0.103462 4.74894 0.103462C 4.8662 0.103462 4.97312 0.134503 5.06968 0.196578C 5.16624 0.258657 5.22832 0.344875 5.25591 0.455239L 6.83891 6.34229L 8.55639 0.351773C 8.59088 0.227619 8.64952 0.137952 8.73229 0.0827703C 8.82195 0.0275887 8.93921 4.6792e-08 9.08405 4.6792e-08ZM 18.2041 4.6792e-08C 18.3558 4.6792e-08 18.4834 0.051733 18.5869 0.155195C 18.6903 0.258657 18.7421 0.386263 18.7421 0.538009L 18.7421 7.54244C 18.7421 7.69422 18.6869 7.82179 18.5765 7.92525C 18.4731 8.02871 18.3489 8.08046 18.2041 8.08046C 18.0523 8.08046 17.9247 8.02871 17.8212 7.92525C 17.7178 7.82179 17.6661 7.69422 17.6661 7.54244L 17.6661 2.40034L 15.1622 7.50105C 15.045 7.68042 14.8898 7.77008 14.6967 7.77008C 14.469 7.77008 14.3035 7.66316 14.2001 7.44935L 11.7273 2.49346L 11.7273 7.54244C 11.7273 7.69422 11.6756 7.82179 11.5721 7.92525C 11.4686 8.02871 11.341 8.08046 11.1893 8.08046C 11.0375 8.08046 10.9099 8.02871 10.8065 7.92525C 10.703 7.82179 10.6513 7.69422 10.6513 7.54244L 10.6513 0.538009C 10.6513 0.386263 10.703 0.258657 10.8065 0.155195C 10.9099 0.051733 11.0375 4.6792e-08 11.1893 4.6792e-08C 11.3962 4.6792e-08 11.5548 0.0965646 11.6652 0.289698L 14.738 6.44574L 17.7282 0.289698C 17.8385 0.0965646 17.9971 4.6792e-08 18.2041 4.6792e-08ZM 20.7019 8.08046C 20.5501 8.08046 20.4226 8.02871 20.3191 7.92525C 20.2156 7.82179 20.1639 7.69422 20.1639 7.54244L 20.1639 0.538009C 20.1639 0.379366 20.2156 0.251759 20.3191 0.155195C 20.4226 0.051733 20.5501 4.6792e-08 20.7019 4.6792e-08L 25.3784 4.6792e-08C 25.537 4.6792e-08 25.6647 0.0482844 25.7612 0.144849C 25.8578 0.234516 25.9061 0.355221 25.9061 0.506967C 25.9061 0.651816 25.8578 0.769073 25.7612 0.858744C 25.6647 0.948412 25.537 0.993243 25.3784 0.993243L 21.2399 0.993243L 21.2399 3.50738L 24.2093 3.50738C 24.361 3.50738 24.4852 3.55566 24.5818 3.65226C 24.6852 3.74193 24.7369 3.85918 24.7369 4.00402C 24.7369 4.14886 24.6852 4.26958 24.5818 4.36614C 24.4852 4.4558 24.361 4.50066 24.2093 4.50066L 21.2399 4.50066L 21.2399 7.54244C 21.2399 7.69422 21.1882 7.82179 21.0847 7.92525C 20.9812 8.02871 20.8536 8.08046 20.7019 8.08046Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileWmfBw);
export default __webpack_public_path__ + "static/media/file-wmf-bw.a7b1c24ae32c9ef8b418b649d04a3508.svg";
export { ForwardRef as ReactComponent };